import * as React from "react";
import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import AdaptationTaskEdit from "./AdaptationTaskEdit";
import AdaptationTaskList from "./AdaptationTaskList";

type Props = RouteComponentProps<{ entityId?: string }>;

@observer
export class AdaptationTaskManagement extends React.Component<Props> {
  static PATH = "/adaptationTaskManagement";
  static NEW_SUBPATH = "new";

  render() {
    // const { entityId } = this.props.match.params;
    return (
      <>
          <AdaptationTaskList />
        {/* {entityId ? (
          // <AdaptationTaskEdit entityId={entityId} />
        ) : (
        )} */}
      </>
    );
  }
}
